import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useDocumentTitleStore } from '../store/DocumentTitle/useDocumentTitleStore';

export function useDocumentTitle(title: string | undefined) {
  const { t } = useTranslation();
  const setPageTitle = useDocumentTitleStore((s) => s.setPageTitle);

  useEffect(() => {
    const appName = t('appName');
    setPageTitle(title ? `${appName} - ${title}` : appName);
  }, [title, t, setPageTitle]);
}
